module.exports = __webpack_public_path__ + "img/4.7c3162c6.png";